<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && allCamera.length===0">{{ $t('camera.no_camera_available') }}</span>

  <span class="centerized title grey--text text-xs-center" v-else-if="!loading && filteredCamera.length===0">{{ $t('camera.no_camera_matched') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xl4 lg6 md6 sm12 xs12 v-for="d in filteredCamera" :key="d.key">
      <camera-item :device="d" :faceReference="userFace" @setting="onCameraSetting" @fullscreen="onFullscreen"></camera-item>
    </v-flex>
  </v-layout>

  <camera-edit-dialog v-if="dialogEditor" v-model="dialogEditor" :camera="dialogEditorCamera" @toast="val=>$emit('toast',val)"></camera-edit-dialog>

  <v-dialog v-model="dialogFullscreen" fullscreen lazy @keydown.esc="dialogFullscreen=false">
    <camera-view :src="dialogFullscreenImageUrl" @close="dialogFullscreen=false"></camera-view>
  </v-dialog>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import CameraItem from './CameraItem'
import CameraEditDialog from './CameraEditDialog'
import CameraView from './CameraView'

export default {
  name: 'Camera',
  mixins: [UserAuth],
  components: {
    'camera-item': CameraItem,
    'camera-edit-dialog': CameraEditDialog,
    'camera-view': CameraView
  },
  data() {
    return {
      userCastTrigger: {},
      dialogEditor: false,
      dialogEditorCamera: null,
      dialogFullscreen: false,
      dialogFullscreenImageUrl: null
    }
  },
  computed: {
    loading() {
      return this.cameraLoading;
    },
    allCamera() {
      let list = [];
      Object.values(this.userCamera).forEach(gateway => {
        Object.keys(gateway).forEach(id => {
          let device = gateway[id];
          let [mac, uid, cid] = id.split('-');
          list.push({
            ...device,
            key: id,
            mac: mac,
            uid: uid,
            cid: cid,
            hostname: (this.userMacInfo[mac] || {}).hostname,
            targetName: ((this.userTargetName[mac] || {})[uid] || {})[cid],
            trigger: this.userCastTrigger[id]
          });
        });
      });
      return list;
    },
    filteredCamera() {
      let data = this.allCamera;
      if (data) {
        if (this.searchGateway && this.searchGateway.length > 0)
          data = data.filter(item => item.mac === this.searchGateway);

        if (this.searchKeyword && this.searchKeyword.length > 0)
          data = data.filter(item => [item.name, item.targetName].join(' ').toLowerCase().indexOf(this.searchKeyword.toLowerCase()) != -1);
      }
      return data;
    }
  },
  methods: {
    onCameraSetting(camera) {
      this.dialogEditorCamera = camera;
      this.dialogEditor = true;
    },
    onFullscreen(imageUrl) {
      if (imageUrl) {
        this.dialogFullscreenImageUrl = imageUrl;
        this.dialogFullscreen = true;
      }
    }
  },
  mounted() {
    this.$bindAsObject('userCastTrigger', this.$db.ref('userCastTrigger').child(this.userId));
  },
  beforeDestroy() {
    this.$db.ref('userCastTrigger').off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/Camera.vue